//
//
//
//
//
//
//
//
//
//
//

import uniIcon from "@/components/uni-icon/uni-icon.vue"
export default{
  data () {
    return {
      memberName: '',
      loading:false,
      iconShow:false
    }
  },
  components:{uniIcon},
  watch:{
    memberName(val,old){
      if(val.length>0){
        this.iconShow = true
      } else {
        this.iconShow = false
      }
    }
  },
  onLoad () {
    this.queryData()
  },
  methods: {
    name(e){
      this.memberName=e.target.value
    },
    //内容清空
    clearContent(){
      this.memberName = ''
    },
    //获取信息
    queryData () {
      let _this = this
      this.$ajax({
        method: 'post',
        url: '/weChat/member/queryById',
        data: {
          memberId: this.$store.state.userInfo.id
        },
        success(res){
          _this.memberName = res.data.memberName
        }
      })
    },
    //更新
    update () {
      let _this = this
      if (_this.testName(_this.memberName) || !_this.memberName) {
         _this.loading = true
        this.$ajax({
          method: 'post',
          url: '/weChat/member/updateById',
          data: {
            memberId: this.$store.state.userInfo.id,
            memberName: _this.memberName
          },
          success(res){
            _this.loading = false
            uni.navigateBack({
              delta: 1
            })
          }
        })
      } else {
        uni.showToast({
          title: '联系人不可包含特殊字符和数字',
          icon: 'none'
        })
      }
    },
    testName () {
      return /^[\u4E00-\u9FA5A-Za-z]+$/.test(this.memberName)
    }
  }
}
